import { ChangeDetectorRef, Component, HostBinding, Input, OnChanges } from '@angular/core';

/**
 * Composant utilisé pour le rendu des sockets (Input et Output) des noeuds.
 */
@Component({
    imports: [],
    templateUrl: './custom-socket.component.html',
    styleUrl: './custom-socket.component.scss'
})
export class CustomSocketComponent implements OnChanges {
    /**
     * Données de la socket.
     */
    @Input() data!: any;

    /**
     * Fonction a appeler lorsque le rendu de la socket est terminé (facultatif).
     */
    @Input() rendered!: any;

    /**
     * Intitullé de la socket (Nom affiché)
     */
    @HostBinding('title') get title() {
        return this.data.name;
    }

    /**
     * Constructeur.
     * @param cdr : Reference au detecteur de changement Angular.
     */
    constructor(private cdr: ChangeDetectorRef) {
        this.cdr.detach();
    }

    /**
     * Appellé lorsqu'un changement est detecté sur le composant.
     */
    ngOnChanges(): void {
        this.cdr.detectChanges();
        requestAnimationFrame(() => this.rendered());
    }
}
